<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">Chi tiết lịch sử tạo serial number</div>
      </div>
      <div class="card card-w-title" v-if="$myConstants.checkRoleGroup('serial_number_add', 'view_history_serial_number')">
        <div class="box-top-list-serial-number" >
          <div class="box-import" v-if="modelData && modelData.status == 0 && checkVisible('serial_number_add', 'import')">
          <!-- <div class="box-import" v-if="modelData && modelData.status == 0"> -->
            <div class="box-title">Import xác nhận serial number đã sản xuất</div>
            <div class="import-data">
              <!-- <button class="download-file" @click="downloadFileSample">
                <i class="pi pi-download"></i>Tải mẫu file import
              </button> -->
              <div class="box-form-import">
                <!-- <InputText readonly="true" id="filename" type="text" v-model="filename" /> -->
                <Button :disabled="files.length > 0" :label="'Chọn file'" @click="openFile" :class="(files.length > 0 ? ' disabled ' : '') + 'item-inline-import'"/>
                <input id="files" ref="files" type="file" style="display:none" @change="chooseFile"/>
                <div :class="'item-inline-import middle-inline' + (files.length > 0 ? '' : ' normal')">
                  <label :class="files.length > 0 ? '' : 'normal'">{{filename}}</label>
                  <a @click="removeFile" v-if="files.length > 0" >Xoá</a>
                </div>
                <Button :disabled="files.length == 0" :class="(files.length > 0 ? '' : 'background-none') + ' disabled-opacity item-inline-import'" :label="'Import'"  @click="importData" />
              </div>
            </div>
          </div>
          <span class="right-button">
            <Button class="p-button-warning" :label="'Quay lại'" @click="backList" />
          </span>
          <div class="clearfix"></div>
          <div :class="'button-function ' + (modelData && modelData.status == 0 ? '' : 'normal-format')">
            <button class="print-all" @click="printQrCode" v-if="modelData && (modelData.status == 0 || modelData.status == 1) && checkVisible('serial_number_add', 'print')">
              <i class="pi pi-print"></i>
              <span v-html="'In tất cả<br/>QR Code'"></span>
            </button>
            <!-- <button class="print-selected" @click="printQrCodeOne" v-if="modelData && (modelData.status == 0 || modelData.status == 1) && checkVisible('print')"> -->
            <button class="print-selected" @click="printQrCodeOne" v-if="modelData && (modelData.status == 0 || modelData.status == 1) && checkVisible('serial_number_add', 'print_select')">
              <i class="pi pi-print"></i>
              <span v-html="'In QR Code<br/>được chọn'"></span>
            </button>
            <button class="download-file" @click="downloadFile" v-if="checkVisible('serial_number_add', 'download_list')">
              <i class="pi pi-download"></i>
              <span>Tải danh sách</span>
            </button>
            <!-- <button class="cancel-serial-number" @click="cancelSerialNumber" v-if="modelData && (modelData.status == 0) && checkVisible('cancel')"> -->
            <button class="cancel-serial-number" @click="cancelSerialNumber" v-if="modelData && (modelData.status == 0) "><!--&& checkVisible('serial_number_add', 'cancel')-->
              <i class="material-icons"> cancel</i>
              <span>Huỷ tất cả serial number</span>
            </button>
          </div>
        </div>
        <div class="p-fluid ">
          <div class="p-col-12 p-grid">
            <div class="list-data p-col-7">
              <div class="list-title">
                <span class="p-m-0">Danh sách lịch sử tạo serial number</span>
              </div>
              <BaseCommon v-if="dataModel"
                :key="componentKey"
                :listData="listData"
                :model="dataModel"
                :filterDefault="filters"
                :isCheckBox="true"
                :headerCheckBox="'Chọn'"
                @row-select="onRowSelected"
                @row-select-all="onRowSelectedAll"
              ></BaseCommon>
            </div>
            <div class="view-serial-number p-offset-1 p-col-4">
              <div class="box-info-title">Hình ảnh QR Code (minh hoạ)</div>
              <templateSerialNumber :key="componentKeyQRcode" class="custom-qr-code" :title="title" :note="note" :hotline="hotline" :codeValue="$myConstants.getUrlChecker() + '/check-warranty-detail/' + serialNumber" :modelCode="model_code" :serialNumber="serialNumber"/>
              <div class="box-info-title">Thông tin chung</div>
              <div class="form-info">
                <div class="p-field">
                  <label>Trạng thái</label>
                  <span v-html="status_text"></span>
                </div>
                <div class="p-field">
                  <label>2 ký tự đầu</label>
                  <span >{{ prefix }}</span>
                </div>
                <div class="p-field">
                  <label>Ngày sản xuất</label>
                  <span>{{ date_production }}</span>
                </div>
                <div class="p-field">
                  <label>Lệnh sản xuất</label>
                  <span > {{ production_code }}</span>
                </div>
                <div class="p-field">
                  <label>Model sản phẩm</label>
                  <span>{{ model_code }}</span>
                </div>
                <div class="p-field">
                  <label>Tên sản phẩm</label>
                  <span>{{ model_name }}</span>
                </div>
                <div class="p-field">
                  <label>Số lượng tạo</label>
                   <span > {{ amount }}</span>
                </div>
                <div class="p-field">
                  <label>Số lượng đã sản xuất</label>
                  <span>{{ amount_production }}</span>
                </div>
                <div class="p-field">
                  <label>Số lượng không sản xuất</label>
                  <span>{{ amount_not_production }}</span>
                </div>
                <div class="p-field">
                  <label>Thời gian tạo</label>
                  <span>{{ created_date }}</span>
                </div>
                <div class="p-field">
                  <label>Người tạo</label>
                  <span>{{ created_users }}</span>
                </div>
                <div class="p-field">
                  <label>Thời gian cập nhật</label>
                  <span>{{ modified_date }}</span>
                </div>
                <div class="p-field">
                  <label>Người cập nhật</label>
                  <span>{{ modified_users }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <PopupMessage :width="30" :key="importComponentKey" :popup_type = "'serial_number'" @export-excel="exportDataExcel" :textExist="textExist"  :messages="messages" :displayDialog="displayDialog" @accept="acceptImport" @cancel="cancelImport"/>
    <Dialog
      class="popup-confirm"
      header="Xác nhận"
      :visible.sync="showDeleteDialog"
      :contentStyle="{overflow: 'visible'}"
      :modal="true"
      :showHeader="true"
      :style="{width: '40vw'}"
    >
      Bạn đồng ý hủy tất cả serial number trong danh sách ?
      <template
        #footer
      >
        <Button label="Đồng ý" @click="acceptCancel()" />
        <Button class="p-button-danger" label="Huỷ" @click="showDeleteDialog = false"/>
      </template>
    </Dialog>
    <Dialog
      class="popup-confirm"
      header="In QR Code"
      :visible.sync="showPrintDialog"
      :contentStyle="{overflow: 'visible'}"
      :modal="true"
      :showHeader="true"
      :style="{width: '30vw'}"
    >
       <div class="p-fluid">
          <div class="p-col-12 form-popup-custom txt-center">
            <div class="p-field">
                <span>Số lượng tem in của 1 QR Code</span>
                <InputNumber v-model="number" :min="0" :class="''"/>
            </div>
          </div>
       </div>
      <template
        #footer
      >
        <Button label="Đồng ý" @click="printQRCodeAccept()" />
        <Button class="p-button-danger" label="Huỷ" @click="showPrintDialog = false"/>
      </template>
    </Dialog>
  </div>
</template>

<script>
import axios from 'axios'
import moment from "moment";
import DataServices from '@/core/DataServices'
import BaseCommon from '../common'
import PopupMessage from '../common/popupMessage'
import XLSX from 'xlsx'
import Api from '@/services'
import templateSerialNumber from '../common/templateSerialNumber'
export default {
  components: {
    BaseCommon,
    PopupMessage,
    templateSerialNumber
  },
  data() {
    return {
        filters: {},
        listData: [],
        dataModel: null,
        componentKey: 0,
        componentKeyQRcode: 0,
        production_code: '',
        modelData: {},
        status_text: '',
        prefix: '',
        date_production: '',
        model_code: '',
        model_name: '',
        amount: 0,
        amount_production: 0,
        amount_not_production: 0,
        created_date: '',
        created_users: '',
        modified_date: '',
        modified_users: '',
        lstProducts: [],
        filename: 'Không có file đang chọn',
        files: [],
        urlFile: window.location.origin + '/upload/files/Template_import_confirm_serial_number.xlsx',
        parse_key: ['Serial number',	'Trạng thái sản xuất'],
        parse_header: [],
        displayDialog: false,
        importComponentKey: 0,
        messages: {},
        textExist: '',
        codeData: '',
        componentPrint:  Math.random() * 1201,
        componentPrintAll: Math.random() * 101,
        title: '',
        note: '',
        hotline: '',
        showDeleteDialog: false,
        serialNumber: '12345678912',
        number: 3,
        showPrintDialog: false,
        isAll: false,
    }
  },
  
  watch: {
    '$route': 'initData'
  },
  async mounted () {
    if (this.$route.params.id !== undefined && !isNaN(this.$route.params.id)) {
      this.production_order_id = this.$route.params.id;
      await this.getData();
      await this.initData();
      await this.getSettings();
      localStorage.removeItem('products');
    }
  },
  methods: {
    checkVisible(groupName, action) {
      return this.$myConstants.checkVisible(this.$store.getters.permission, groupName, action);
    },
    initData() {
      setTimeout(async () => {
        if (this.checkVisible('serial_number_add', 'download_list')  || this.checkVisible('serial_number_add', 'print_select')  || this.checkVisible('serial_number_add', 'print')  || this.checkVisible('serial_number_add', 'import') ) {/*|| this.checkVisible('serial_number_add', 'cancel')*/
          this.$store.commit('setDataLoading', {content: 'Đang tải dữ liệu', icon: true});
          this.$store.commit('setLoading', true);
          await this.initParams();
          this.$store.commit('setLoading', false);
        }
      }, 1000);
    },
    backList() {
       this.$router.push({path: '/admin/serial-number/add'});
    },
    async getSettings() {
      var variables = {
        where_key: {
          key: {'_in': ['QR_SERIAL_NUMBER_TITLE', 'QR_SERIAL_NUMBER_NOTE', 'QR_SERIAL_NUMBER_HOTLINE']}
        },
        orderBy: {
          key: 'desc'
        }
      }
      var data = await DataServices.getList('settings', {"variables": JSON.stringify(variables), 'fields' : 'key value'});
      if (data != undefined && data != null && data[Object.keys(data)].length) {
        var lists = data[Object.keys(data)];
        var objTitle = lists.filter(a => a.key == 'QR_SERIAL_NUMBER_TITLE');
        if (objTitle && Object.keys(objTitle).length) {
          this.title = objTitle[0].value;
        }
        var objNote = lists.filter(a => a.key == 'QR_SERIAL_NUMBER_NOTE');
        if (objNote && Object.keys(objNote).length) {
          this.note = objNote[0].value;
        }
        var objHotline = lists.filter(a => a.key == 'QR_SERIAL_NUMBER_HOTLINE');
        if (objHotline && Object.keys(objHotline).length) {
          this.hotline = objHotline[0].value;
        }
      }
    },
    printQRCodeAccept() {
      var that = this;
      if (this.isAll) {
        var listFilter = this.listData.map(a => ({product: {model_code: a.product.model_code}, serial_number: a.serial_number}))
        localStorage.setItem('products', JSON.stringify(listFilter));
        setTimeout(() => {
          let routeData = this.$router.resolve({name: 'serial_number_print', query: {num: that.number}});
          window.open(routeData.href, '_blank');
        }, 500);
      } else {
        if (this.componentPrint > 0 && this.lstProducts.length ) {
          var listFilterOne = this.lstProducts.map(a => ({product: {model_code: a.product.model_code}, serial_number: a.serial_number}))
          localStorage.setItem('products', JSON.stringify(listFilterOne));
          setTimeout(() => {
            let routeData = this.$router.resolve({name: 'serial_number_print', query: {num: that.number}});
            window.open(routeData.href, '_blank');
          }, 500);
        }
      }
    },
    printQrCode() {
      this.showPrintDialog = true;
      this.isAll = true;
    },
    printQrCodeOne() {
      if (this.componentPrint > 0 && this.lstProducts.length ) {
        this.showPrintDialog = true;
        this.isAll = false;
      }
    },
    cancelSerialNumber() {
      this.showDeleteDialog = true;
    },
    async acceptCancel() {
      var params = {
        modifier_id: this.$store.getters.fullname.id,
        modified_date: this.$myConstants.currentDate(),
        status: 2
      }
      await DataServices.updateData('production_order', {"variables": JSON.stringify({data_update: params, where_key: { id: {'_eq': this.production_order_id }}})});
      this.showDeleteDialog = false;
      setTimeout(() => {
        window.location.reload();
      }, 100);
    },
    downloadFile() {
      if (this.lstProducts.length == 0) this.lstProducts = this.listData;
      if (this.lstProducts.length > 0) {
        this.$store.commit('setDataLoading', {content: 'Đang tải file', icon: true});
        this.$store.commit('setLoading', true);
        var vm = this;
        setTimeout(() => {
          vm.exportExcel();
        }, 2000);
      }
    },
    exportExcel() {
      var dataJson = []
        for (let index = 0; index < this.lstProducts.length; index++) {
          var item = this.lstProducts[index];
          var statusText = item.production_status == 1 ? 'x' : '';
          dataJson.push({
            // 'STT': (index + 1),
            'Serial number':  item.serial_number,
            'Trạng thái sản xuất': statusText,
            'Lệnh sản xuất':  this.production_code, 
            'Ngày sản xuất':   (item.production_order != undefined && item.production_order != null) ? moment(item.production_order.manufacturing_date).format('DD/MM/YYYY') : '', 
            'Model sản phẩm':  (item.product != undefined && item.product != null) ? item.product.model_code : '', 
            'Tên sản phẩm':  (item.product != undefined && item.product != null) ? item.product.name : ''
          })
        }
        if (dataJson !== null) {
          var dataSheet = XLSX.utils.json_to_sheet(dataJson);
          const workBook = {
            SheetNames: ['Template_serialNumber'], // sheet name
            Sheets: {
              'Template_serialNumber': dataSheet,
            }
          };
          XLSX.writeFile(workBook, 'Template_export_serialNumber.xlsx')
          window.location.reload();
          this.$store.commit('setLoading', false);
        }
    },
    async initParams() {
      this.listData = [];
      this.modelName = 'product_serial_number_view';
      var variables = {
        where_key: {
          production_status: {'_in': [0, 1, 2] },
          production_order_id: {'_eq': this.production_order_id},
          status: {'_eq': 1}
        },
        orderBy: {
          modified_date: 'desc_nulls_last'
        }
      }
      var data = await DataServices.getList(this.modelName, {"variables": JSON.stringify(variables)});
      var list = data[Object.keys(data)];
      this.dataModel = DataServices.getModel(this.modelName);
      this.dataModel.processData(list);
      this.listData = list;
      this.componentKey++;
      this.componentPrintAll =  Math.random() * 108;
    },
    async getData() {
      this.modelName = 'production_order';
      var variables = {
        where_key: {
          id: {'_eq': this.production_order_id }
        }
      }
      var data = await DataServices.getList(this.modelName, {"variables": JSON.stringify(variables), "fields": "production_order_code prefix_number amount created_date modified_date manufacturing_date status users { full_name } modifier_users { full_name } product { model_code name } product_serial_number_aggregate(where: {production_status: {_eq: 1}, production_order_id: {_eq: \"" + this.production_order_id + "\"}}) { aggregate { count } } product_serial_number_not_production_aggregate(where: {production_status: {_eq: 2}, production_order_id: {_eq: \"" + this.production_order_id + "\"}}) { aggregate { count } }"});
      var list = data[Object.keys(data)];
      if (list != null && Object.keys(list).length) {
        this.modelData = list[0];
        this.production_code = this.modelData.production_order_code;
        if (this.modelData.status == 0) this.status_text =  '<abbr class="p-class-status p-class-danger">Mới</abbr>';
        else if (this.modelData.status == 1) this.status_text =  '<abbr class="p-class-status  p-class-success">Hoàn thành</abbr>';
        else if (this.modelData.status == 2) this.status_text =  '<abbr class="p-class-status  p-class-cancel">Hủy</abbr>';
        this.prefix = this.modelData.prefix_number;
        this.date_production = (this.modelData.manufacturing_date != undefined && this.modelData.manufacturing_date != null) ? moment(this.modelData.manufacturing_date).format('DD/MM/YYYY') : '';
        this.model_code = (this.modelData.product != undefined && this.modelData.product != null) ? this.modelData.product.model_code : '';
        this.model_name = (this.modelData.product != undefined && this.modelData.product != null) ? this.modelData.product.name : '';
        this.amount = this.modelData.amount;
        this.amount_production = (this.modelData.product_serial_number_aggregate != undefined && this.modelData.product_serial_number_aggregate != null && this.modelData.product_serial_number_aggregate.aggregate != null) ? this.modelData.product_serial_number_aggregate.aggregate.count : 0;
        this.amount_not_production = (this.modelData.product_serial_number_not_production_aggregate != undefined && this.modelData.product_serial_number_not_production_aggregate != null && this.modelData.product_serial_number_not_production_aggregate.aggregate != null) ? this.modelData.product_serial_number_not_production_aggregate.aggregate.count : 0;
        this.created_date = moment.tz(this.modelData.created_date, this.$myConstants.timeZone()).format('DD/MM/YYYY HH:mm');
        // this.created_date = moment.utc(this.modelData.created_date).local().format('DD/MM/YYYY HH:mm');
        this.created_users = (this.modelData.users != undefined && this.modelData.users != null) ? this.modelData.users.full_name : '';
        if (this.modelData.modifier_users == undefined || this.modelData.modifier_users == null || this.modelData.modifier_users == '') this.modified_date = '';
        else {
          this.modified_date = moment.tz(this.modelData.modified_date, this.$myConstants.timeZone()).format('DD/MM/YYYY HH:mm');
          // moment.utc(this.modelData.modified_date).local().format('DD/MM/YYYY HH:mm');
        }
        this.modified_users = (this.modelData.modifier_users != undefined && this.modelData.modifier_users != null) ? this.modelData.modifier_users.full_name : '';
      }
      this.componentKeyQRcode++;
    },
    onRowSelectedAll() {
      this.lstProducts = this.listData;
    },
    onRowSelected(data) {
      this.lstProducts = data;
      this.componentPrint = Math.random() * 102;
    },
    openFile() {
      this.$refs.files.click();
    },
    removeFile() {
      this.files = [];
      document.getElementById("files").value = null;
      this.filename = 'Không có file đang chọn';
    },
    chooseFile($event) {
      $event.preventDefault();
      var fileSelects = $event.target.files || $event.dataTransfer.files;
      if (!fileSelects.length)
        return;
      var file = fileSelects[0].name;
      var extension = this.$myConstants.getFileExtension(file);
      this.files = [];
      if (['xlsx', 'xls'].includes(extension)) {
        this.files.push(fileSelects);
        this.filename = file;
      } else {
        this.filename = 'Không có file đang chọn';
        this.files = [];
        document.getElementById("files").value = null;
        this.errorsText = 'Import thất bại do sai template';
        this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: this.errorsText, life: 3000 })
      }
    },
    async importData() {
      if (this.files.length > 0) {
        this.$store.commit('setDataLoading', {content: 'Đang kiểm tra file import', icon: true});
        this.$store.commit('setLoading', true);
        var vm = this;
        var file = this.$refs.files.files[0];
        var reader = new FileReader();
        reader.onload = function(e) {
          var data = e.target.result, 
          fixedData = vm.fixedData(data), 
          workbook = XLSX.read(btoa(fixedData), {type: 'base64'}), 
          firstSheetName = workbook.SheetNames[0],
          worksheet = workbook.Sheets[firstSheetName];
          vm.fileInputData = worksheet;
          if (firstSheetName != 'Template_serialNumber') {
            vm.$store.commit('setLoading', false);
            vm.files = [];
            vm.filename = 'Không có file đang chọn';
            document.getElementById("files").value = null;
            vm.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Import thất bại do sai template', life: 3000 })
          } else {
            vm.processImport(file, vm.fileInputData);
          }
        };
        reader.readAsArrayBuffer(file);
      }
    },
    async processImport(file, worksheet) {
      await this.checkWorkSheetToJson(file, worksheet);
    },
    getHeaderRow(sheet) {
      var headers = [], range = XLSX.utils.decode_range(sheet['!ref']);
      var C, R = range.s.r; /* start in the first row */
      for(C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
          var cell = sheet[XLSX.utils.encode_cell({c:C, r:R})] /* find the cell in the first row */
          if (cell !== undefined) {
            var hdr = "UNKNOWN " + C; // <-- replace with your desired default 
            if(cell && cell.t) hdr = XLSX.utils.format_cell(cell);
            headers.push(hdr);
          }
      }
      return headers;
    },
    fixedData(data) {
      var o = "", l = 0, w = 10240;
      for(; l<data.byteLength/w; ++l) o+=String.fromCharCode.apply(null,new Uint8Array(data.slice(l*w,l*w+w)));
      o+=String.fromCharCode.apply(null, new Uint8Array(data.slice(l*w)));
      return o;
    },
    async checkWorkSheetToJson(file, worksheet) {
      var vm = this;
      var headerChange = vm.getHeaderRow(worksheet);
      vm.parse_header.push(headerChange[0]);
      vm.parse_header.push(headerChange[1]);

      var headerText = vm.parse_header.join(',').toLowerCase().replace(/\s/g, '').trim();
      var parseHeader = vm.parse_key.join(',').toLowerCase().replace(/\s/g, '').trim();
     
      if (vm.parse_key.length < vm.parse_header.length || vm.parse_key.length > vm.parse_header.length || parseHeader != headerText) {
        this.$store.commit('setLoading', false);
        this.errorsText = 'Import thất bại do sai template';
        this.filename = 'Không có file đang chọn';
        this.files = [];
        document.getElementById("files").value = null;
        this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: this.errorsText, life: 3000 })
      }
      else  {
        var results = XLSX.utils.sheet_to_json(worksheet);
        if (results != null && results.length != undefined && results.length > 5001) {
          this.$store.commit('setLoading', false);
          this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Dữ liệu đã vượt quá 5000 dòng, vui lòng kiểm tra lại file import', life: 3000 })
        } else {
          let formData = new FormData();
          formData.append('file', file)
          await Api.post('/product_serial_number/check-data-import', formData, { headers: { 'productionOrderID': this.production_order_id } })
          .then(async (response) => {
            await vm.checkCondition(response.data);
          })
          .catch(async (error) => {
            vm.$store.commit('setLoading', false);
            vm.$toast.add({ severity: 'error', summary: 'Thông báo', detail: error, life: 3000 })
          });
        }
      }
    },
    downloadFileSample() {
      var filename = this.$myConstants.getFileName(this.urlFile);
      axios({
        url: this.urlFile,
        method: 'GET',
        responseType: 'blob',
        }).then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', filename);
          document.body.appendChild(fileLink);
          fileLink.click();
      });
    },
    async checkCondition(response) {
      this.displayDialog = true;
      this.$store.commit('setLoading', false);
      this.messages = response.data.message;
      this.exportData = response.data.payload;
      this.importComponentKey = Math.random()*300;
      this.textExist = ' dòng serial number không đúng';
    },
    async checkImportProcessing() {
      var vm = this;
      var payload = {
        productionOrderID: vm.production_order_id,
        dataImport:  vm.exportData
      }
      await Api.post('/product_serial_number/import', payload)
        .then( async () => {
          var params = { modified_date: this.$myConstants.currentDate(), modifier_id:vm.$store.getters.fullname.id };
          await DataServices.updateData('production_order', {"variables": JSON.stringify({data_update: params, where_key: { id: {'_eq': vm.production_order_id }}})});
          vm.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Import thành công', life: 3000 })
          vm.$store.commit('setLoading', false);
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }).catch(async (error) => {
          vm.$store.commit('setLoading', false);
          vm.$toast.add({ severity: 'error', summary: 'Thông báo', detail: error, life: 3000 })
      });
    },
    exportDataExcel() {
      if (this.exportData.length > 0) {
        this.$store.commit('setDataLoading', {content: 'Đang tải file', icon: true});
        this.$store.commit('setLoading', true);
        var vm = this;
        setTimeout(() => {
          vm.exportExcelError();
        }, 2000);
      }
    },
    exportExcelError() {
      var dataJson = [];
      for (let index = 0; index < this.exportData.length; index++) {
        var item = this.exportData[index];
        dataJson.push({
            // 'STT': (index + 1),
            'Serial number':  (item['Serial number'] != undefined && item['Serial number'] != null) ? item['Serial number']: '',
            'Trạng thái sản xuất': (item['Trạng thái sản xuất'] != undefined && item['Trạng thái sản xuất'] != null) ? item['Trạng thái sản xuất']: '',
            'Lệnh sản xuất':  (item['Lệnh sản xuất'] != undefined && item['Lệnh sản xuất'] != null) ? item['Lệnh sản xuất']: '',
            'Ngày sản xuất':  (item['Ngày sản xuất'] != undefined && item['Ngày sản xuất'] != null) ? item['Ngày sản xuất']: '',
            'Model sản phẩm':  (item['Model sản phẩm'] != undefined && item['Model sản phẩm'] != null) ? item['Model sản phẩm']: '',
            'Tên sản phẩm':  (item['Tên sản phẩm'] != undefined && item['Tên sản phẩm'] != null) ? item['Tên sản phẩm']: '',
            'note': (item['message'] != undefined && item['message'] != null) ? item['message']: ''
          });
      }
      if (dataJson !== null) {
        var dataSheet = XLSX.utils.json_to_sheet(dataJson) 
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, dataSheet)
        XLSX.writeFile(wb, 'Template_import_confirm_serial_number.xlsx')
        this.$store.commit('setLoading', false);
      }
    },
    async acceptImport() {
      this.displayDialog = false;
      this.importComponentKey = Math.random()*380;
      this.$store.commit('setDataLoading', {content: 'Đang import dữ liệu', icon: true});
      this.$store.commit('setLoading', true);
      this.waittingImport();
    },
    async cancelImport() {
      this.displayDialog = false;
      this.importComponentKey = Math.random()*350;
      this.filename = 'Không có file đang chọn';
      this.files = [];
      document.getElementById("files").value = null;
      // window.location.reload();
    },
    async waittingImport() {
      var vm = this;
      var stop = await vm.checkImportProcessing();
      if (stop) {
        vm.$store.commit('setLoading', false);
      }
     
    }
  }
}
</script>

<style lang="scss">
.create-serial-number{ margin: 0 auto; width: 800px;
    .p-field{
        &.width-prefix{width: 125px;}
        &.width-amount{margin-left: 20px; width: 200px; margin-right: 100px;}
        &.width-300{width: 350px;
            &.margin-right{margin-right: 100px;}
        }
        label{font-size: 14px;}
        &.btn-submit{ margin: 20px auto 0 auto;
            .p-button{width: 200px !important; 
                &.disabled{background: #999999; border: 1px solid #999999;}
            }
        }
    }
}
.p-class-status{ padding: 3px 15px; border-radius: 5px;color: #fff;
  &.p-class-danger { background: rgba(172, 41, 37, 1);  }
  &.p-class-success{background:  rgba(0, 153, 0, 1); }
  &.p-class-cancel{background:  rgba(102, 102, 102, 1); }
}
.box-top-list-serial-number{ margin-bottom: 0px;
  .box-import{display: inline-block;}
  .right-button{float: right;}
}
.view-serial-number{
  .box-info-title{ margin-bottom: 20px;}
  .form-info{
    .p-field{ padding: 10px;
      &:nth-child(n) {background: #E4E4E4;}
      &:nth-child(2n) {background: #fff;}
      label{ width: 200px; margin: 0;}
    }
  }
}

.button-function { display: block;margin: 15px; padding-top: 20px; border-top: 1px solid #ccc;
  button{ margin-right: 26px; display: inline-flex; align-items: center;  font-size: 14px;
    &:last-child{margin: 0;}
    i{font-size: 25px;}
  }
  .download-file{color: #fff;  border-width: 0px; min-width: 165px; height: 50px; background: rgba(22, 155, 213, 1); border: none; border-radius: 5px; padding: 5px 20px;
    i{padding-right: 10px;}
  }
  .print-selected{ color: #fff;  border-width: 0px; width: 150px; height: 50px; background: rgba(153, 0, 255, 1); border: none; border-radius: 5px; padding: 5px 15px;
    i{padding-right: 10px;}
  }
  .print-all{ color: #fff;  border-width: 0px; width: 150px; height: 50px; background: rgba(0, 153, 0, 1); border: none; border-radius: 5px; padding: 5px 15px;
    i{padding-right: 10px;}
  }
  &.normal-format{border: 0; padding: 0; margin: 0;  margin-bottom: 20px; margin-left: 10px;
    .download-file{height: 50px;}
  }
  .cancel-serial-number{position: relative; top:4px;  color: #fff;  border-width: 0px; width: 163px; height: 50px;  background: rgba(172, 41, 37, 1); border: none; border-radius: 5px; padding: 5px 15px;
    i{padding-right: 5px; font-size: 30px;}
  }
}
.form-popup-custom{
  .p-inputnumber{display: inline-flex; width:70px !important; margin-left: 10px;
    .p-inputnumber-input{text-align: center;}
  }
}
.custom-qr-code {
  .qr-custom{width: 150px !important; height: 150px !important;}
}
</style>